import React from "react";
import Navbar from "../navbar/Navbar";
import Home from "../home/Home";

import Footer from "../pages/Frontend/homePage/components/footer/Footer";

function DefaultStructure() {
  return (
    <div className="custom-scroll">
      <Navbar />
      <Home />
      <Footer />
    </div>
  );
}

export default DefaultStructure;
